var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "fill-row-loading" },
      [
        _c("h4", [_vm._v("Descargando AEC (Archivo Electronico de Cesión)")]),
        _vm._l(_vm.types, function(type) {
          return _c("div", {
            key: type,
            staticClass: "vs-con-loading__container loading-example",
            class: { activeLoading: _vm.activeLoading },
            attrs: { id: ["loading-" + type] }
          })
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }